<script lang="ts" generics="TValues">
    import { type ParticipantInput } from '$gql/graphql';
    import SelectMyParticipant from '$components/Feed/SelectMyParticipant/SelectMyParticipant.svelte';
    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import type { ComponentProps } from 'svelte';

    export let form: Form<TValues, string>;
    export let field: Field<TValues, ParticipantInput>;

    export let portal: ComponentProps<SelectMyParticipant>['portal'] = null;

    export let title: ComponentProps<SelectMyParticipant>['title'] = null;
    export let only: ComponentProps<SelectMyParticipant>['only'] = [];

    let className = '';
    export { className as class };

    $: value = form.stores().fieldValue(field);
</script>

<SelectMyParticipant
    value={$value}
    onChange={(v) => {
        form.dispatch(form.actions().changeValue(v, field));
    }}
    onFocus={() => {
        form.dispatch(form.actions().focus(field));
    }}
    onBlur={() => {
        form.dispatch(form.actions().focus(field));
    }}
    {portal}
    {only}
    {title}
    class={className}
/>
